import api from './axios';
import { getTokenCurrentCustomer } from '../../utils/authenticated-user';
import encode from '../../utils/token';
import { handleSessionExpiration } from '../../utils/api';
import { createBrowserHistory } from 'history'; // Import history for redirection

const history = createBrowserHistory(); // Create a history instance

const callAPI = async (options, additionalHeaders = {}) => {
  var headers = { ...additionalHeaders };
  const tokenCurrentCustomer = getTokenCurrentCustomer();
  if (tokenCurrentCustomer) {
    headers = { ...headers, Authorization: `Bearer ${await encode(tokenCurrentCustomer)}` };
  }

  const optionsUpdated = { ...options, headers };

  try {
    const response = await api(optionsUpdated);
    return response;
  } catch (error) {
    if (error.response && (error.response.status === 403 || error.response.status === 401)) {
      // Redirect to login page on 403 or 401
      history.push('/login'); // Adjust the path to your login page
      sessionStorage.removeItem('customer'); // Clear session if needed
      localStorage.removeItem('customer'); // Clear session if needed
      handleSessionExpiration('customer');
      window.location.href = '/login';
    }
    throw error; // Re-throw the error for further handling
  }
};

export default callAPI;
